import axios from "axios";
import apiInstance from "./axios";

const insuranceApi = {
  /**
   * Submit a new insurance application.
   * Auth token is sent automatically by axios (cookie/header).
   */
  createApplication: async (applicationData) => {
    const response = await apiInstance.post(
      "/insurance/applications",
      applicationData
    );
    return response;
  },

  /**
   * Get all applications for the authenticated golfer.
   * Uses a separate axios instance to avoid the global 401 redirect interceptor.
   * If the user isn't authenticated, this should fail silently (caller handles it).
   */
  getMyApplications: async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/insurance/applications`,
      {
        timeout: 10000,
        withCredentials: true,
        headers: {
          ...apiInstance.defaults.headers,
        },
      }
    );
    return response;
  },

  /**
   * Get a single application by reference number (public, no auth required).
   */
  getApplication: async (refId) => {
    const response = await apiInstance.get(
      `/insurance/applications/${encodeURIComponent(refId)}`
    );
    return response;
  },

  /**
   * Update an application (admin only).
   * Auth token is sent automatically by axios (cookie/header).
   * @param {string} refId - Reference number of the application
   * @param {Object} updates - Fields to update, e.g. { status: 'pending' }
   */
  updateApplication: async (refId, updates) => {
    const response = await apiInstance.post(
      `/insurance/applications/${encodeURIComponent(refId)}`,
      updates
    );
    return response;
  },
};

export default insuranceApi;
